import React, { useEffect, Fragment } from 'react'
import { useHistory } from 'react-router-dom'
import { getURLParameterByName } from '../services/utils'
import config from '../config';

const Main = () => {
    const history = useHistory()

    // TM: Updated for URL parameter handling
    useEffect(() => {
        const purecloudInitialization = async () => {
            let env = getURLParameterByName('environment')
            if (!env) env = config.purecloud.name
            sessionStorage.setItem('purecloud-csp-env', env)

            // Handle PKCE authorization code exchange
            const authCode = new URLSearchParams(window.location.search).get('code')
            if (authCode) {
                // Validate state to prevent CSRF
                const returnedState = new URLSearchParams(window.location.search).get('state')
                const expectedState = sessionStorage.getItem('pkce-state')

                if (!returnedState || returnedState !== expectedState) {
                    console.error('ISGW: PKCE state mismatch — possible CSRF attack')
                    history.push('/unauthorized')
                    return
                }

                const codeVerifier = sessionStorage.getItem('pkce-code-verifier')
                if (!codeVerifier) {
                    console.error('ISGW: PKCE code verifier missing — restarting login')
                    history.push('/login')
                    return
                }

                try {
                    console.info('ISGW: Exchanging authorization code for token (PKCE)')

                    const params = new URLSearchParams({
                        grant_type: 'authorization_code',
                        code: authCode,
                        redirect_uri: `${window.location.protocol}//${window.location.host}`,
                        client_id: config.purecloud.clientId,
                        code_verifier: codeVerifier
                    })

                    const response = await fetch(`https://login.${env}/oauth/token`, {
                        method: 'POST',
                        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
                        body: params.toString()
                    })

                    if (!response.ok) throw new Error(`Token exchange failed: ${response.status}`)

                    const data = await response.json()
                    sessionStorage.setItem('purecloud-csp-token', data.access_token)

                    if (data.refresh_token) {
                        sessionStorage.setItem('purecloud-refresh-token', data.refresh_token)
                    }

                    sessionStorage.removeItem('pkce-code-verifier')
                    sessionStorage.removeItem('pkce-state')
                    window.history.replaceState({}, document.title, window.location.pathname)
                    console.info('ISGW: PKCE token exchange successful')
                } catch (error) {
                    console.error('ISGW: PKCE token exchange error:', error)
                    history.push('/unauthorized')
                    return
                }
            }

            // Handle implicit grant token from URL hash
            const accessToken = getURLParameterByName('access_token');
            if (accessToken) {
                sessionStorage.setItem('purecloud-csp-token', accessToken)
                console.info(`ISGW: Got token from URL params`)
            }
            if (sessionStorage.getItem('purecloud-csp-token')) {
                console.info("ISGW: Loaded token from session storage");
                try {
                    history.push('/home')
                } catch (error) {
                    history.push('/unauthorized', error.message)
                }
            }
            else {
                console.info("ISGW: redirect to login - should be logged into Genesys Cloud first");
                history.push('/login')
            }
        }
        const pureconnectInitialization = () => {
            if (sessionStorage.getItem('pureconnect-csrf-token')) {
                history.push('/home')
            } else {
                history.push('/login')
            }
        }
        switch (config.product) {
            case 'purecloud': purecloudInitialization()
                break;
            case 'pureconnect': pureconnectInitialization()
                break;
            case 'pureengage':
                break;
            default:
                break;
        }
        // eslint-disable-next-line
    }, [])

    return (<Fragment></Fragment>)
}

export default Main